import {START_UPDATEINITIALFLOWFLAG,END_UPDATEINITIALFLOWFLAG} from "./action";

const initState   =     {
    isProgress:false,
    error:null,
    success:null
}

export  function initialFlowFlagReducer(state=initState,action){
    switch(action.type){
        case START_UPDATEINITIALFLOWFLAG:
            return {
                ...state,
                isProgress:true,
                error:null,
                success:null
            };
        case END_UPDATEINITIALFLOWFLAG:
            return {
                ...state,
                isProgress:false,
                error:action.payload.error,
                success:action.payload.success
            }
        default:
            return state;
    }
}